import React, { useEffect, useState, useCallback } from 'react'
import { keys, find, isEmpty } from 'lodash'
import FILTERED_TYPE from '../constant'
import LoadingModal from '../../LoadingModal'
import Button from '../../Button'
import ActiveFilters from '../../ActiveFilters'
import {
  getDefaultFilter,
  getUserFilteredColumnsStorageByUser,
  removeFromStoreByName,
  saveSelectedFilter
} from '../storeUtils'
import { showActiveFiltersPivot } from '../helpers/helpersPivot'
import { showActiveFilters } from '../helpers/helpersTable'
import { Dropdown } from '../../Dropdown'

const TableGetInfoFilterModal = ({ open, close, data }) => {
  const { tableApi, userId, identifier, t, type, linksByUri } = data
  const defaultValue = { id: 'none', model: {} }
  const [selectedRadio, setSelectedRadio] = useState(
    getDefaultFilter({ userId, identifier, type }).name || defaultValue.id
  )
  const [radioList, setRadioList] = useState([defaultValue.id])
  const [columnsInfo, setColumnsInfo] = useState({})
  const [columnsSaved, setColumnsSaved] = useState([])
  const [ubliqueLinks, setUbliqueLinks] = useState([])
  useEffect(() => {
    if (open) {
      if (type === FILTERED_TYPE.TABLE) setUbliqueLinks(linksByUri())
    }
  }, [open])

  useEffect(() => {
    const saved = getUserFilteredColumnsStorageByUser(userId, type)
    setColumnsSaved(saved)
    if (keys(saved).includes(identifier)) {
      const wtFilterList = saved[identifier]
      const list = wtFilterList.map((field) => field.name)
      setRadioList([defaultValue.id, ...list])
      setColumnsInfo(getModelFromId(selectedRadio ?? defaultValue.id))
    }
  }, [])

  const onSaveModal = () => {
    if (type === FILTERED_TYPE.PIVOT) {
      isEmpty(columnsInfo)
        ? tableApi.gridCore.columnApi.resetColumnState()
        : tableApi.gridCore.columnApi.setColumnState(columnsInfo)
    } else {
      tableApi.gridCore.filterManager.setFilterModel(columnsInfo)
      tableApi.gridCore.filterManager.onFilterChanged()
    }

    saveSelectedFilter({
      selectedFilter: selectedRadio,
      userId,
      identifier,
      type
    })

    close()
  }

  const getModelFromId = (id) => {
    if (id === defaultValue.id) return defaultValue.model
    const filterList = columnsSaved[identifier] || []
    const obj = find(filterList, { name: id })

    return obj?.model ?? defaultValue.model
  }

  useEffect(() => {
    setColumnsInfo(getModelFromId(selectedRadio))
  }, [selectedRadio, columnsSaved])

  const onChangeDropdown = (selItem) => {
    setSelectedRadio(selItem)
  }

  const removeSelectedFilter = () => {
    if (selectedRadio === defaultValue.id) return

    if (removeFromStoreByName(selectedRadio, type, identifier, userId)) {
      const columnsSaved = getUserFilteredColumnsStorageByUser(userId, type)
      const filterList = columnsSaved[identifier]
      const list = filterList.map((field) => field.name)
      setRadioList([defaultValue.id, ...list])
      setColumnsInfo({})
      setSelectedRadio(defaultValue.id)
    }
  }
  const customHeaderModal = useCallback(() => {
    return (
      <div className='modal-header bx--modal-header__heading'>
        <h4>{t('FilterMenu.ColumnsChooseFilterModal.TITLE')}</h4>
      </div>
    )
  }, [t])

  const footerCustom = () => {
    return (
      <>
        <Button kind='secondary' size='default' onClick={close}>
          {t('Translations:Cancel')}
        </Button>

        <Button kind='danger' size='default' onClick={removeSelectedFilter}>
          {t('Translations:Delete')}
        </Button>
        <Button kind='primary' size='default' onClick={onSaveModal}>
          {t('Translations:Apply')}
        </Button>
      </>
    )
  }

  const activeFilters =
    type === FILTERED_TYPE.PIVOT
      ? showActiveFiltersPivot(columnsInfo, tableApi, t)
      : showActiveFilters(columnsInfo, tableApi, ubliqueLinks)

  return (
    <LoadingModal
      size='md'
      open={open}
      onRequestClose={close}
      footerCustom={footerCustom()}
      modalHeading={customHeaderModal()}
      className='columnsFilter-modal-inputview'
      preventCloseOnClickOutside
    >
      <Dropdown
        itemToString={(id) => t(id)}
        items={radioList.map((id) => id)}
        selectedItem={selectedRadio}
        label=''
        onChange={({ selectedItem }) => onChangeDropdown(selectedItem)}
      />
      <ActiveFilters filters={activeFilters} labels='' />
    </LoadingModal>
  )
}

export default TableGetInfoFilterModal
